import React from 'react';
import { translate } from 'react-i18next';

import { NAMESPACE } from '../services/i18n';

interface TranslationHOCProps {
  t: TranslationFunction;
}

const withTranslate = <Props extends TranslationHOCProps>(
  WrappedComponent: React.ComponentClass<Props> | React.StatelessComponent<Props>,
) => translate([NAMESPACE])(WrappedComponent);

export default withTranslate;
